import React from "react";
import "./graph-interval-selector-dialog.scss";
import dataCalculators from "../data-calculators";
import GraphRepresentativeCmpx from "../../report-page1/graph-representative-cmpx";
import IntervalSelector from "./graph-selector/interval-selector";

class GraphIntervalSelectorDialog extends React.Component {
    state = {};
    componentDidMount() {
        const { data } = this.props;
        this.setState({
            ...data
        });
    }

    onSubmit = e => {
        e.preventDefault();
        const { onSave, onClose, needCmpxVerification } = this.props;
        const data = {
            ...this.state
        };

        if (needCmpxVerification) {
            data.verificated = true;
        }
        onSave(data);
        onClose();
    };

    onClose = () => {
        const { onClose } = this.props;
        const tempData = {
            ...this.state
        };
        onClose(tempData);
    };

    onCancel = () => {
        const { onClose } = this.props;
        onClose();
    };
    onChanged = data => {
        this.setState(oldState => dataCalculators(oldState, data, this.props.fd));
    };

    render() {
        const { loc, needCmpxVerification, cmpxVerificated } = this.props;
        if (Object.entries(this.state).length === 0 && this.state.constructor === Object) {
            return null;
        }

        const { P, PDur, Q, QTmax, S } = this.state;
        const editedIntervals = { P, PDur, Q, QTmax, S };
        return (
            <div className="popup-window popup-window_opened graphSelector-popup-window">
                <button type="button" className="popup-close-btn" onClick={() => this.onClose()}>
                    &times;
                </button>
                <form id="GraphSelectorForm" className="graphSelector__form" action="#" onSubmit={this.onSubmit}>
                    <h3 className="form-header">{loc("dialogs.intervalSelector.title")}</h3>

                    <div className="form-content">
                        <GraphRepresentativeCmpx
                            editMode={false}
                            areasInsteadTicks={true}
                            editedIntervals={editedIntervals}
                            mode="PopupDialog"
                        />
                        <div>
                            <IntervalSelector loc={loc} onChanged={this.onChanged} data={this.state} />
                        </div>
                    </div>

                    <div className="form-footer">
                        {needCmpxVerification && (
                            <div className="message-block">
                                {cmpxVerificated ? (
                                    <span className="message-block__text success_text">
                                        {loc("dialogs.intervalSelector.cmpxIsVerificated")}
                                    </span>
                                ) : (
                                    <span className="message-block__text warning-text">
                                        {loc("dialogs.intervalSelector.verificationAgreement")}
                                    </span>
                                )}
                            </div>
                        )}
                        <input type="submit" className="button button-ok" value={loc("buttons.ok")} />
                        <input
                            type="reset"
                            className="button button-cancel"
                            value={loc("buttons.cancel")}
                            onClick={() => this.onCancel()}
                        />
                    </div>
                </form>
            </div>
        );
    }
}

export default GraphIntervalSelectorDialog;
